"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Login/MFA/CodeForm.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Form = require('web/components/Form');
var _AuthFrame = require('web/components/AuthFrame');
var _components = require('web/screens/Signup/components');
var _mfaErrors = require('shared/constants/mfaErrors');










const CODE_LENGTH = 6
const RESEND_COOLDOWN_SECONDS = 30
const ERROR_ID = 'mfa-code-error'

const formatCooldown = (seconds) => `0:${String(seconds).padStart(2, '0')}`

const defaultIntro = (phone) => (
  _react2.default.createElement(_react2.default.Fragment, null, "We texted a code to "     ,  phone , " to confirm it's you."    )
)

const CodeForm = ({
  maskedPhone, onBack, onSubmit, onResend, intro = defaultIntro,
}) => {
  const [code, setCode] = _react.useState.call(void 0, '')
  const [error, setError] = _react.useState.call(void 0, '')
  const [isSubmitting, setIsSubmitting] = _react.useState.call(void 0, false)
  const [isResending, setIsResending] = _react.useState.call(void 0, false)
  const [resendCooldown, setResendCooldown] = _react.useState.call(void 0, RESEND_COOLDOWN_SECONDS)

  _react.useEffect.call(void 0, () => {
    if (resendCooldown <= 0) {
      return undefined
    }

    const timeout = setTimeout(() => setResendCooldown(resendCooldown - 1), 1000)
    return () => clearTimeout(timeout)
  }, [resendCooldown])

  const onChange = (value) => {
    setCode(value)
    if (error) setError('')
  }

  const submit = (e) => {
    e.preventDefault()
    if (code.length < CODE_LENGTH || isSubmitting) return
    setIsSubmitting(true)
    setError('')
    onSubmit(code)
      .catch(e => setError(_mfaErrors.mfaErrorMessage.call(void 0, e)))
      .finally(() => setIsSubmitting(false))
  }

  const resend = () => {
    setIsResending(true)
    setError('')
    onResend()
      .then(() => setResendCooldown(RESEND_COOLDOWN_SECONDS))
      .catch(e => {
        if (_optionalChain([e, 'optionalAccess', _ => _.response, 'optionalAccess', _2 => _2.Error]) === 'MFA Code Recently Sent') {
          setResendCooldown(RESEND_COOLDOWN_SECONDS)
        }
        setError(_mfaErrors.mfaErrorMessage.call(void 0, e))
      })
      .finally(() => setIsResending(false))
  }

  const phone = _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 74}},  maskedPhone || 'your phone' )

  // A countdown until a new code may be sent, then the Resend action.
  const resendRow = (
    _react2.default.createElement('div', { className: "auth-links", __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
      ,  resendCooldown > 0
        ? (
            _react2.default.createElement('span', { className: "auth-small", 'aria-live': "polite", __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}, "Didn't get it? Resend in "
                   ,  formatCooldown(resendCooldown) 
            )
          )
        : (
            _react2.default.createElement('button', {
              type: "button",
              className: "auth-link",
              disabled: isResending,
              onClick: resend, __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}
, "Resend code"

            )
          )
      
    )
  )

  return (
    _react2.default.createElement('form', { onSubmit: submit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}
      , _react2.default.createElement('p', { className: "auth-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}},  intro(phone) )
      , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
        , _react2.default.createElement(_AuthFrame.CodeInput, {
          autoFocus: true,
          value: code,
          onChange: onChange,
          length: CODE_LENGTH,
          hasError: !!error,
          describedBy: error ? ERROR_ID : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}
        )
        , _react2.default.createElement(_AuthFrame.FieldError, { id: ERROR_ID, __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}},  error )
      )
      ,  onBack
        ? (
            _react2.default.createElement(_react2.default.Fragment, null
              ,  resendRow 
              , _react2.default.createElement('div', { className: "signup-step--controls", __self: this, __source: {fileName: _jsxFileName, lineNumber: 117}}
                , _react2.default.createElement(_components.BackArrow, { onClick: onBack, __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}} )
                , _react2.default.createElement(_Form.Button, { isSubmit: true, isDisabled: code.length < CODE_LENGTH, isLoading: isSubmitting, __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}, "Verify"

                )
              )
            )
          )
        : (
            _react2.default.createElement(_react2.default.Fragment, null
              , _react2.default.createElement(_Form.Button, { isSubmit: true, isDisabled: code.length < CODE_LENGTH, isLoading: isSubmitting, __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}}, "Verify"

              )
              ,  resendRow 
            )
          )
      
    )
  )
}

exports. default = CodeForm
